import { PublicClientApplication } from '@azure/msal-browser'
import { setupFullStoryConsentWatcher } from './services/fullStory'

const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AAD_SAML_CLIENTID,
    authority: import.meta.env.VITE_AAD_SAML_ENTRY_POINT,
    redirectUri: import.meta.env.VITE_AAD_SAML_CALLBACK_URL
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true
  }
}

const msalInstance = new PublicClientApplication(msalConfig)

;(async () => {
  const hasMsalHash =
    window.location.hash.includes('id_token') ||
    window.location.hash.includes('access_token') ||
    window.location.hash.includes('code')

  // Initialize MSAL before anything else
  await msalInstance.initialize()

  if (hasMsalHash) {
    try {
      const response = await msalInstance.handleRedirectPromise()
      if (response) {
        const redirectPath = sessionStorage.getItem('postLoginRedirect') ?? '/'
        sessionStorage.removeItem('postLoginRedirect')
        sessionStorage.setItem('__deferred_redirect__', redirectPath)

        location.replace(location.href.split('#')[0])
      }
    } catch (error) {
      console.error('MSAL redirect handling error:', error)
    }
  }

  const { createApp } = await import('vue')
  const { createPinia } = await import('pinia')
  const { default: App } = await import('./App.vue')
  const { default: router } = await import('./router')
  const { useSearchStore } = await import('./stores/search')

  await import('tailwindcss/tailwind.css')
  await import('@/assets/scss/style.scss')

  const app = createApp(App)
  const pinia = createPinia()

  app.use(pinia)
  app.use(router)
  app.provide('msalInstance', msalInstance)

  const searchStore = useSearchStore()

  // Only fetch the (authenticated) Algolia config when a user is already signed in
  if (msalInstance.getAllAccounts().length > 0) {
    await searchStore.loadAlgoliaConfig().catch((error) => {
      console.error('Failed to load Algolia search configuration:', error)
    })
  }

  app.mount('#app')

  setupFullStoryConsentWatcher()

  const deferredRedirect = sessionStorage.getItem('__deferred_redirect__')
  if (deferredRedirect) {
    sessionStorage.removeItem('__deferred_redirect__')
    router.replace(deferredRedirect)
  }
})()
